/**
 * Assessment segments: each has its own time limit and is stored under a distinct layer.
 * Layer 5 = Career Dialogues (Q&A, like 1–4); questions are generated with full prior context.
 */
export const ASSESSMENT_SEGMENTS = [
  {
    id: "ocean",
    layer: 1,
    title: "Understanding Your Personality",
    description: "Big Five (OCEAN) — how you think, feel, and behave",
    estimatedMinutes: 14,
    questionKind: "ocean" as const,
  },
  {
    id: "riasec",
    layer: 2,
    title: "Discovering Your Interests",
    description: "Holland codes — what activities and careers fit you",
    estimatedMinutes: 18,
    questionKind: "riasec" as const,
  },
  {
    id: "iq",
    layer: 3,
    title: "Thinking & Problem-Solving",
    description: "Logical and analytical reasoning",
    estimatedMinutes: 10,
    questionKind: "iq" as const,
  },
  {
    id: "eq",
    layer: 4,
    title: "Real-world Emotions",
    description: "Emotional intelligence in everyday scenarios",
    estimatedMinutes: 8,
    questionKind: "eq" as const,
  },
  {
    id: "career_dialogue",
    layer: 5,
    title: "Career Dialogues",
    description: "Short questions about flow, strengths, and career aspirations",
    estimatedMinutes: 12,
    questionKind: "career_dialogue" as const,
  },
] as const;

export type SegmentId = (typeof ASSESSMENT_SEGMENTS)[number]["id"];
export type SegmentLayer = (typeof ASSESSMENT_SEGMENTS)[number]["layer"];

/** Layer used for the AI interview transcript in assessments table */
export const INTERVIEW_LAYER = 5;

export function getSegmentBySlug(slug: string) {
  return ASSESSMENT_SEGMENTS.find((s) => s.id === slug) ?? null;
}

export function getSegmentByLayer(layer: number) {
  return ASSESSMENT_SEGMENTS.find((s) => s.layer === layer) ?? null;
}
